<template>
  <div class="sn-page sn-assembly sn-f-c-c loading-page">
    <div class="loading-blank"></div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'loading'
};
</script>
<style lang="scss">
.loading-page {
  .loading-blank {
    width: 18px;
    height: 18px;
    background: url(../../../public/images/loading.gif) no-repeat center;
  }
}
</style>
